import imageHero from "../assets/img/ai/hero_image.png";
import Hand from "../assets/img/ai/hand.png";
import Hands from "../assets/img/ai/hands.png";
import Robot from "../assets/img/ai/company_robot.svg";
import Background from "../assets/img/ai/hero-background.png";


export const data = {
    hero: {
        title: 'AI Development & Integration',
        text: [
            'Are you ready to revolutionize your business with the power of Artificial Intelligence? Look no further! Agilistry specializes in providing top-notch AI development and integration services that can help you harness the true potential of AI for your business.'
        ],
        image: imageHero,
        image_back: Background,
    },
    about: {
        title: 'What is AI?',
        text: [
            'AI, or Artificial Intelligence, is a field of computer science focused on the development of intelligent machines that can perform tasks that would normally require human intelligence.'
        ],
        image: Hand
    },
    services: {
        title: 'Services Offered by AI Service Providers',
        text: [
            'An AI service provider typically offers a range of services designed to help businesses leverage the power of AI to improve efficiency, reduce costs, and enhance customer experience.'
        ],
        image: Hands,
        list: [
            {
                title: 'AI Consulting',
                desc: 'AI consulting involves working with businesses to understand their unique needs and identify areas where AI can be applied to deliver maximum value.'
            },
            {
                title: 'AI Development',
                desc: 'AI development involves developing custom AI solutions tailored to the specific needs of a business. This may involve developing AI algorithms, creating machine learning models, or building chatbots.'
            },
            {
                title: 'AI Integration',
                desc: 'AI integration involves integrating AI solutions into a business’s existing systems and processes, ensuring seamless integration and maximum efficiency.'
            },
            {
                title: 'AI Training',
                desc: 'AI training involves training employees on how to use AI systems and tools effectively, ensuring that they are able to take full advantage of the benefits of AI.'
            },
            {
                title: 'AI Maintenance and Support',
                desc: 'AI maintenance and support involves providing ongoing maintenance and support for AI systems and tools, ensuring that they continue to operate at peak performance.'
            },
        ]
    },
    company: {
        title: 'Why choose Agilistry for AI development?',
        content: [
            'With <span>years of experience</span>  and a <span>team of expert developers</span>, we offer a wide range of AI development services tailored to your unique needs.',
        ],
        content2: [
            'Whether you\'re looking to develop custom AI algorithms, machine learning models, or chatbots, we have <span>the expertise and experience to deliver results.</span>  So why wait? Choose Agilistry for your AI development needs today and experience the power of AI for your business!\n',
        ],
        image: Robot

    }
}